import { useEffect, useState } from 'react'

/**
 * Delays a value so a search box does not fire a request per keystroke.
 *
 * 300ms is the usual compromise: below ~200ms you are still issuing a request
 * mid-word, above ~500ms the list feels detached from the typing.
 */
export function useDebounced<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(t)
  }, [value, delay])
  return debounced
}
